import { FieldConfig } from '../../restaurant/models';

export function getEnabledCustomFieldNames(partyFields: FieldConfig[]): string[] {
  return partyFields.filter(({enabled}) => enabled).map(({name}) => name);
}
